import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=2597471c&scoped=true&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"
import style0 from "./Providers.vue?vue&type=style&index=0&id=2597471c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597471c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VChip,VDataTable,VDialog,VDivider,VIcon,VProgressCircular,VProgressLinear,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})


/* vuetify-loader */
import installDirectives from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
